export default __webpack_public_path__ + "static/media/entp@3x.3ba7c570.png";